import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuPaginatorComponent } from './au-paginator-component/au-paginator.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PaginationControlService } from '@app/pages/files/services/pagination-control.service';

@NgModule({
	imports: [CommonModule, MatPaginatorModule, AuPaginatorComponent],
	exports: [AuPaginatorComponent],
	providers: [PaginationControlService],
})
export class AuPaginatorModule {}
